import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Label, StyledValue } from '../../AlertStyles';

const Date = ({ children }) => {
  if (!children) {
    return null;
  }
  return (
    <Label>
      Date <StyledValue>{moment(children).format('MMM DD, YYYY')}</StyledValue>
    </Label>
  );
};

Date.defaultProps = {
  children: null,
};

Date.propTypes = {
  children: PropTypes.string,
};

export default Date;
